// Renders placeholder skeleton sections into the given container while the
// configuration is being fetched.
export function showSkeletonLoading(container) {
  container.innerHTML = '';
  container.classList.add('item-card-configurator--loading');
  container.setAttribute('aria-busy', 'true');
  container.setAttribute('role', 'status');

  const title = document.createElement('span');
  title.className = 'skeleton-loading item-card-configurator__skeleton-title';
  container.appendChild(title);

  const sectionsWrapper = document.createElement('div');
  sectionsWrapper.className = 'item-card-configurator__skeleton-sections';

  for (let i = 0; i < 2; i++) {
    sectionsWrapper.appendChild(createSkeletonSubsection());
  }

  container.appendChild(sectionsWrapper);
}
export function hideSkeletonLoading(container) {
  container.classList.remove('item-card-configurator--loading');
  container.removeAttribute('aria-busy');
  container.removeAttribute('role');
  container.innerHTML = '';
}

function createSkeletonSubsection() {
  const subsection = document.createElement('div');
  subsection.className = 'dtp-field--skeleton';

  const label = document.createElement('span');
  label.className = 'skeleton-loading item-card-configurator__skeleton-label';
  subsection.appendChild(label);

  const input = document.createElement('span');
  input.className = 'skeleton-loading item-card-configurator__skeleton-input';
  subsection.appendChild(input);

  const message = document.createElement('span');
  message.className = 'skeleton-loading item-card-configurator__skeleton-message';
  subsection.appendChild(message);

  return subsection;
}
